import { Button } from "../../Common/Button"
import { useAppDispatch, useAppSelector } from "../../../Redux/store"
import { setGameUrl } from "../../../Redux/gameSlice";
import { useEffect, useState } from "react";
import { InteractionScreen, setScreen } from "../../../Redux/screenInteractionsSlice";
import { setModal } from "../../../Redux/uiSlice";
import { copyToClipboard } from "../../../helpers/copy";
import { removeLastCharacter } from "../../../helpers/string";
import { ModalUI } from "../ModalUI";
import { explorerUrl } from "../../../const/urls";

interface IProps {
    onClose(): void;
}
export const InsertGameModal: React.FC<IProps> = ({ onClose: _onClose }) => {
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [inputValue, setInputValue] = useState<string>('');
    const dispatch = useAppDispatch();
    const gameUrl = useAppSelector(state => state.game.gameUrl);
    // const navigate = useNavigate();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (errorMessage) setErrorMessage('');
        if (!inputValue && gameUrl) dispatch(setGameUrl(''));
        setInputValue(e.currentTarget.value);
    }

    useEffect(() => {
        if (gameUrl) {
            setInputValue(gameUrl.split('/')[gameUrl.split('/').length - 1])
        }
    }, []);

    const onPlay = () => {

        if (!inputValue?.length) {
            return setErrorMessage('No Game Inserted!');
        }

        dispatch(setModal(undefined))
        dispatch(setScreen(InteractionScreen.GAME));
        dispatch(setGameUrl(`${explorerUrl}${inputValue}`));
    };

    const onClose = () => _onClose();

    const onEject = () => {
        if (!inputValue?.length) {
            return setErrorMessage('No Game Inserted!');
        }

        setInputValue('');
        dispatch(setGameUrl(''));
        // navigate('/');
    }

    const onCopy = () => {
        if (!inputValue?.length) {
            return setErrorMessage('No Game Inserted!');
        }

        const string = `${removeLastCharacter(window.location.href)}?game=${inputValue ?? gameUrl.split('/')[gameUrl.split('/').length - 1]}`;
        copyToClipboard(string);
    }

    return (
        <ModalUI maxHeight={200} maxWidth={380} onClose={onClose} >
            <p className="interactions-text text-sm text-center">
                {gameUrl ? 'Game Options' : 'Insert Game'}
            </p>
            <div className="w-11/12 flex justify-center items-center">
                <input
                    className="interactions-text text-xs w-11/12 h-12 text-center px-4"
                    style={{ border: 'solid 2px grey' }}
                    type="text"
                    placeholder="Enter Inscription TX ID"
                    onChange={onChange}
                    value={inputValue}
                />
            </div>
            {errorMessage ? <p className="interactions-text text-xs text-center">
                {errorMessage}
            </p> : null}
            <div className="flex justify-center gap-8">
                <Button variant="text" text="Play" onClick={onPlay} className="border-none shadow-none text-sm p-2 w-14 bg-antiqueWhite" />
                <Button variant="text" text="Share" onClick={onCopy} alertMessage="Copied!" className="border-none shadow-none text-sm p-2 w-14 bg-antiqueWhite" />
                <Button variant="text" text="Eject" onClick={onEject} className="border-none shadow-none text-sm p-2 w-14 bg-antiqueWhite" />
            </div>
        </ModalUI>
    )
}